'use strict';

angular.module('mobile-apps')
    .directive('detectWidth', ['$window','$timeout', function($window, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                function doDomStuff(tries) {
                    //console.log("try: " + tries);
                    // a sanity check, just in case we reuse this function as a handler,
                    // e.g. for `orientationchange`
                    if (isNaN(+tries)) {
                        tries = attrs.maxTries || 100;
                    }

                    scope.trynumber = tries;
                    if (tries > 0) {
                        $timeout(function() {
                            var width  = element.width();//$window.getComputedStyle(element[0]).offsetWidth;
                            if (width) {
                                // if width is computed, the element is ready to be manipulated
                                // so manipulate the element here, e.g.:

                                scope[attrs.dwstore] = width;
                                //console.log("width: " + width);
                            } else {
                                // otherwise, the element is not ready, so decrement the tries,
                                // wait a bit, and try again:
                                doDomStuff(tries - 1);
                            }
                        }, attrs.msDelay || 100);
                    } else {
                        // if we got here, we've exhausted our tries, so we probably
                        // want to log or warn or throw here.
                    }
                }

				scope.$watch(function() {return element[0].innerText; }, function(innerText) {
					var width  = element.width();//$window.getComputedStyle(element[0]).offsetWidth;
					if (innerText) {
						doDomStuff(attrs.maxTries);
					}
				});

            }
        };
    }]);
